import InputField from "../../../components/InputField";
import Toggle from "../../../components/Toggle";

export default function ConditiiStep({ data, update, toggleField }) {
  const handleNrPersoaneChange = (e) => {
    const val = e.target ? e.target.value : e;
    if (val === "" || val === null) {
      update("nrMaxPersoane")(val);
      return;
    }
    const numVal = Number(val);
    if (numVal > 20) {
      update("nrMaxPersoane")("20");
    } else {
      update("nrMaxPersoane")(val);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Toggle label="Utilitati suportate de comodatar" description="Comodatarul suporta costul utilitatilor (apa, gaz, electricitate, internet)" checked={data.utilitatiComodatar} onChange={toggleField("utilitatiComodatar")} />
      <Toggle label="Animale de companie permise" description="Comodatarul poate detine animale in imobil" checked={data.animalePermise} onChange={toggleField("animalePermise")} />
      {data.animalePermise && (
        <p style={{ fontSize: "11px", color: "#8a7e70", margin: "-4px 0 0 0", fontStyle: "italic" }}>
          Animalele nu trebuie sa produca daune imobilului.
        </p>
      )}
      <Toggle label="Fumat permis" description="Fumatul este permis in interiorul imobilului" checked={data.fumatPermis} onChange={toggleField("fumatPermis")} />
      <Toggle label="Subcomodare permisa" description="Comodatarul poate permite unor terti sa foloseasca imobilul" checked={data.subcomodarePermisa} onChange={toggleField("subcomodarePermisa")} />
      <div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "16px" }}>
        <InputField label="Nr. maxim persoane" value={data.nrMaxPersoane} onChange={handleNrPersoaneChange} placeholder="ex: 2" type="number" half min={1} max={20} />
        <p style={{ width: "100%", fontSize: "11px", color: "#8a7e70", margin: "-8px 0 0 0" }}>
          Se refera la numarul maxim de persoane care pot locui simultan in imobil.
        </p>
      </div>
    </div>
  );
}
